<app-header></app-header>
<app-booking-header></app-booking-header>

<div class="wrap">
  <main class="main" *ngIf="privacyPolicy != null" [innerHTML]="privacyPolicy.policy">
  </main>
</div>

<app-footer></app-footer>
